import PatientSchema from "./patient";
import TherapysSchema from "./therapy";
import SettingsSchema from "./settings";
import MaterialsSchema from "./materials";
import MaterialsGroupSchema from "./materialGroup";
import ContactsSchema from "./contacts";
import AppointmentsSchema from "./appointments";
import EvidencesSchema from "./docs/evidence";
import AdvicesSchema from "./docs/advice";
import AnamnesenSchema from "./docs/anamnese";
import OrdersSchema from "./docs/order";
import DeliveryNotesSchema from "./docs/deliveryNote";
import DoctorsLettersSchema from "./docs/doctorsLetter";
import OtherDocumentsSchema from "./docs/documents";
import WoundImagesSchema from "./docs/woundImages";
import WoundSummarySchema from "./docs/woundSummary";
import OwnDocSchema from "./docs/ownDoc";

import ActionsSchema from "./actions";
import SharesSchema from "./shares";
import UserSchema from "./user";
import SimpleSchema from "./simple";

export {
  SimpleSchema,
  PatientSchema,
  TherapysSchema,
  SettingsSchema,
  MaterialsSchema,
  MaterialsGroupSchema,
  ContactsSchema,
  AppointmentsSchema,
  EvidencesSchema,
  AdvicesSchema,
  AnamnesenSchema,
  DeliveryNotesSchema,
  DoctorsLettersSchema,
  OtherDocumentsSchema,
  WoundImagesSchema,
  WoundSummarySchema,
  ActionsSchema,
  SharesSchema,
  UserSchema,
  OrdersSchema,
  OwnDocSchema,
};

const SchemaByType = {
  Patient: PatientSchema,
  Therapy: TherapysSchema,
  Settings: SettingsSchema,
  Contact: ContactsSchema,
  Material: MaterialsSchema,
  Appointment: AppointmentsSchema,
  Evidence: EvidencesSchema,
  Anamnese: AnamnesenSchema,
  WoundImage: WoundImagesSchema,
  Document: OtherDocumentsSchema,
  Advice: AdvicesSchema,
  MaterialGroup: MaterialsGroupSchema,
  DoctorsLetter: DoctorsLettersSchema,
  User: UserSchema,
  DeliveryNote: DeliveryNotesSchema,
  Action: ActionsSchema,
  Share: SharesSchema,
  Order: OrdersSchema,
  WoundSummary: WoundSummarySchema,
  OwnDoc: OwnDocSchema,
};

const blacklisted = ["imageMeasure", "docDiff", "services", "twoFactorCode"];

const getSchemaByType = (typename) => {
  let typeDef = `
    _id
    __typename
    `;
  Object.keys(SchemaByType[typename]).map((key) => {
    if (
      key.indexOf("$") === -1 &&
      key.indexOf(".") === -1 &&
      blacklisted.indexOf(key) === -1
    ) {
      typeDef += ` ${key}`;
    }
  });
  return {
    schema: SchemaByType[typename],
    typeDef,
  };
};

export default getSchemaByType;
